type WorkDayCategoryLabels = {
  overwork: string
  pause: string
}

export const PAUSE_IDENTIFIERS = new Set(['W4', 'W5', 'W9'])
export const OVERWORK_IDENTIFIERS = new Set(['W1', 'W2', 'W3', 'W7'])

export function getWorkDayCategoryDisplayIdentifier(
  identifier: string,
  labels: WorkDayCategoryLabels
) {
  if (PAUSE_IDENTIFIERS.has(identifier)) return labels.pause
  if (OVERWORK_IDENTIFIERS.has(identifier)) return labels.overwork

  return identifier
}
